import { useEffect, useRef, useState } from "react";
import { completeSignIn, pendingCallback } from "./lib/omauth";
import { OddsScreen } from "./components/OddsScreen";
import { Logo } from "./components/Logo";

/**
 * Everyone gets the board. Signed out, it reads the public feed (a snapshot, refreshed every
 * minute) with a sign-in CTA; signed in, it reads with the user's own key and streams live. If the
 * public feed isn't set up, OddsScreen falls back to the sign-in page.
 */
export function App() {
  const [completing, setCompleting] = useState(pendingCallback);
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode mounts twice in dev; complete the callback once.
    ran.current = true;
    if (!pendingCallback()) return;
    completeSignIn()
      .then((r) => {
        if (r?.status === "error") setError(r.message);
      })
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)))
      .finally(() => setCompleting(false));
  }, []);

  if (completing) return <Splash />;
  return <OddsScreen signInError={error} />;
}

function Splash() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <Logo size={34} />
      <div className="flex items-center gap-2 text-[13px] text-dim">
        <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-accent border-t-transparent" />
        Signing you in…
      </div>
    </div>
  );
}
